import { render, staticRenderFns } from "./add-item-panel.vue?vue&type=template&id=07c067e5"
import script from "./add-item-panel.vue?vue&type=script&lang=js"
export * from "./add-item-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c067e5')) {
      api.createRecord('07c067e5', component.options)
    } else {
      api.reload('07c067e5', component.options)
    }
    module.hot.accept("./add-item-panel.vue?vue&type=template&id=07c067e5", function () {
      api.rerender('07c067e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/send-list-conversation/add-item-panel.vue"
export default component.exports